// #532 Repeating calendar events — the one-line series summary a booking card
// shows: "every Wednesday at 18:00, from 4 Nov 2026 to 28 Apr 2027 (26 events)".
// Built from the STRUCTURED `series` block the BE puts on calendar_event_created
// ({count, first_start, last_start, rule:{recurrence, days, interval_days,
// wall_time, day_of_month, time_to_be_confirmed}}), so it localizes with the UI
// language instead of echoing the BE's English `summary`.

// 2024-01-01 is a Monday → index 0 = Monday … 6 = Sunday (the BE's numbering).
const weekdayName = (idx, locale) => {
    const d = new Date(Date.UTC(2024, 0, 1 + idx, 12));
    try {
        return d.toLocaleDateString(locale, { weekday: 'long', timeZone: 'UTC' });
    } catch (_) {
        return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][idx];
    }
};

const shortDate = (iso, locale) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
};

const joinList = (items, t) => {
    if (items.length <= 1) return items.join('');
    return `${items.slice(0, -1).join(', ')} ${t('caleSeriesAnd')} ${items[items.length - 1]}`;
};

export function seriesPattern(rule, t, language = 'en') {
    const locale = language === 'es' ? 'es-ES' : 'en-GB';
    const r = rule || {};
    let text;
    if (r.recurrence === 'daily') text = t('caleSeriesDaily');
    else if (r.recurrence === 'weekly') {
        const days = (r.days || []).map((d) => weekdayName(Number(d), locale));
        text = t('caleSeriesWeekly', { days: joinList(days, t) });
    } else if (r.recurrence === 'every_n_days') text = t('caleSeriesEveryN', { n: r.interval_days });
    else text = t('caleSeriesMonthly', { n: r.day_of_month || '' });
    if (r.wall_time && !r.time_to_be_confirmed) text += t('caleSeriesAt', { time: r.wall_time });
    return text;
}

export function seriesSummary(series, t, language = 'en') {
    if (!series || !series.count) return '';
    const locale = language === 'es' ? 'es-ES' : 'en-GB';
    return t('caleSeriesSummary', {
        pattern: seriesPattern(series.rule, t, language),
        first: shortDate(series.first_start, locale),
        last: shortDate(series.last_start, locale),
        count: t(series.count === 1 ? 'caleSeriesCountOne' : 'caleSeriesCount', { n: series.count }),
    });
}
